import { AppState } from 'core/redux/rootReducer';
import IAgreementInstanceData from '../types/IAgreementData';

const selectAgreements = (state: AppState) => state.agreements;

const selectedAgreement = (state: AppState): IAgreementInstanceData | null => selectAgreements(state).selectedAgreement;

const selectedAgreementId = (state: AppState): number | null => {
    return selectAgreements(state).selectedAgreement?.id || null;
};

const selectedAgreementUuid = (state: AppState): string | null => {
    return selectAgreements(state).selectedAgreement?.uuid || null;
};

export default { selectedAgreement, selectedAgreementId, selectedAgreementUuid };
